import React from 'react';
import { FadeIn } from './FadeIn';
export function Story() {
  return <section className="py-24 px-6 bg-cream-dark/30" data-id="element-111">
      <div className="max-w-reading mx-auto" data-id="element-112">
        <FadeIn data-id="element-113">
          <div className="flex items-center gap-4 mb-12" data-id="element-114">
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal italic" data-id="element-115">
              My Story
            </h2>
            <div className="h-px flex-grow bg-amber/30 mt-2" data-id="element-116" />
          </div>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-charcoal/80 leading-relaxed font-light" data-id="element-117">
          <FadeIn delay={0.1} data-id="element-118">
            <p data-id="element-119">
              I've always been the kind of person who wants to know how things
              actually work — not just the surface answer, but the reasoning
              underneath. That's a big part of why the legal field has always
              pulled at me. Law is basically the operating system of how people,
              businesses, and societies make decisions, and I find that
              fascinating.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-120">
            <p data-id="element-121">
              Right now I'm enrolled in the UCLA Paralegal Training Program,
              which has been a great way to actually dig into the practical side
              of things — civil litigation, contracts, legal research, and a lot
              of writing. It's structured, demanding, and exactly the kind of
              environment I wanted to be in.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-122">
            <blockquote className="my-12 pl-6 md:pl-10 border-l-2 border-amber py-2" data-id="element-123">
              <p className="font-playfair text-2xl md:text-3xl text-charcoal italic leading-snug" data-id="element-124">
                "I'd rather do the work right than do it fast — but ideally,
                both."
              </p>
            </blockquote>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-125">
            <p data-id="element-126">
              I'm at the start of this career, but I'm not at the start of
              caring about doing things well. I've spent years getting good at
              showing up prepared, paying attention to the details other people
              miss, and being someone a team can actually count on. I'm looking
              for the right place to put those habits to work.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}